<template>
  <el-dialog title="添加维度"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="800px">
    <el-form class="widget-form" :model="contents"  label-width="90px" size="medium">
      <table class="table table-bordered margin-tb-10">
        <tr class="bg-light-cyan">
          <th width="90">类型</th>
          <th>维度</th>
        </tr>
        <tr v-for="(item,key) in degreeList" :key="key">
          <td valign="middle">{{ key }}</td>
          <td>
            <el-checkbox-group v-model="factorList">
              <el-checkbox v-for="f in item" :label="f.name">{{ f.name }}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
      </table>
    </el-form>
    <span slot="footer">
				<el-button @click="doClose" size="small"><i class="fa fa-close"></i> 关闭</el-button>
				<el-button type="primary" @click="submit" size="small"><i class="fa fa-save"></i> 确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {fetchDegreeList} from '@/api/rep/dictionary'

  export default {
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    visible: false,
    content:null
  },
  data: function() {
    return {
      contents:{},
      degreeList:[],
      degrees:{},
      factorList:[]
    }
  },
  methods: {
    init(){
      this.contents = {}
      this.degrees = {}
      this.degreeList = []
      this.factorList = []
      fetchDegreeList().then(resp =>{
        this.degreeList = resp.data.result
        if(this.content){
          this.factorList = this.content.map(x => {return x.name})
        }
      })
    },
    doClose() {
      this.$emit('done', false)
    },
    submit(){
      console.info(this.content)
      let backFactors = this.factorList.map(x=>{
        let oldFactor = this.content.filter(o=>o.name === x)
        if(oldFactor && oldFactor.length>0){
          return oldFactor[0]
        }else{
          return {name:x,norm:80}
        }
      })
      console.info(backFactors)
      this.$emit('done', backFactors)
    }
  }
}
</script>
<style lang="scss" scoped>
  .option-table {
    margin: 5px auto;
    border-left: none;
    border-right: none;

    th {
      background-color: #f7f7f7;
    }

    td {
      padding: 5px 8px !important;
      vertical-align: middle;
    }
  }

  .norm-setting-page {
    .el-form-item {
      margin: 0 !important;
    }

    .el-select.el-select--small {
      ::v-deep .el-input__inner {
        border-radius: 2px;
        padding-left: 5px;
      }
    }

    .el-input.el-input--small {
      ::v-deep .el-input__inner {
        border-radius: 2px;
        padding-left: 5px;
      }
    }

    .el-input-number--small {
      width: 70px;

      ::v-deep .el-input--small .el-input__inner {
        padding-left: 5px !important;
        padding-right: 40px;
        border-radius: 2px;
      }
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
